import api from "./api";
import {
  FindRoleActionPermissionsResponse,
  ListPermissionActionsResponse,
  SavePermissionActionPayload,
  SaveRoleActionPermissionsPayload,
} from "../types/SystemActionPermission";

const getAuthHeaders = () => {
  const token = sessionStorage.getItem("authToken");

  if (!token) {
    throw new Error("Token não encontrado");
  }

  return {
    Authorization: `Bearer ${token}`,
  };
};

export async function findAllPermissionActions(params?: {
  module_id?: number;
  module?: string;
}): Promise<ListPermissionActionsResponse> {
  const response = await api.get<ListPermissionActionsResponse>(
    "/permission-actions",
    {
      params,
      headers: getAuthHeaders(),
    },
  );

  return response.data;
}

export async function createPermissionAction(
  payload: SavePermissionActionPayload,
): Promise<void> {
  await api.post("/permission-actions", payload, {
    headers: getAuthHeaders(),
  });
}

export async function updatePermissionAction(
  permissionActionId: string | number,
  payload: SavePermissionActionPayload,
): Promise<void> {
  await api.put(`/permission-actions/${permissionActionId}`, payload, {
    headers: getAuthHeaders(),
  });
}

export async function deletePermissionAction(
  permissionActionId: string | number,
): Promise<void> {
  await api.delete(`/permission-actions/${permissionActionId}`, {
    headers: getAuthHeaders(),
  });
}

export async function findRoleActionPermissions(
  roleId: number,
): Promise<FindRoleActionPermissionsResponse> {
  const response = await api.get<FindRoleActionPermissionsResponse>(
    `/roles/${roleId}/action-permissions`,
    {
      headers: getAuthHeaders(),
    },
  );

  return response.data;
}

export async function saveRoleActionPermissions(
  roleId: number,
  payload: SaveRoleActionPermissionsPayload,
): Promise<void> {
  await api.put(`/roles/${roleId}/action-permissions`, payload, {
    headers: getAuthHeaders(),
  });
}
